export default __webpack_public_path__ + "static/media/ico-plumber.1d239ba7.svg";